module.exports = __webpack_public_path__ + "static/media/7.b209c8b4.jpg";